module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "car-item",
    class: {
      'height-level-0': !_vm.hasTangeche,
      'height-level-1': _vm.hasTangeche && !_vm.data.price,
        'height-level-2': _vm.hasTangeche && _vm.data.price,
        'height-level-2': _vm.supportloan
    },
    style: ({
      width: _vm.width + 'px'
    }),
    attrs: {
      "data-id": _vm.data.id
    }
  }, [_c('div', {
    staticClass: "car-img-container",
    style: ({
      height: _vm.width / 3 * 2 + 'px'
    })
  }, [_c('div', {
    staticClass: "car-img-parent"
  }, [(_vm.vLazy) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.computedImg),
      expression: "computedImg"
    }]
  }) : _c('img', {
    attrs: {
      "src": _vm.computedImg
    }
  })]), _vm._v(" "), (_vm.isNew) ? _c('div', {
    staticClass: "new-icon-parent"
  }, [_c('img', {
    attrs: {
      "src": "//img.souche.com/20170309/png/33d1e2f9c58a75501f15d3a9c351e618.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.data.carStatus === 2) ? _c('div', {
    staticClass: "sold-icon-parent"
  }, [_c('img', {
    attrs: {
      "src": "//img.souche.com/20170309/png/ae4abcd0ac417154a4e0befe7fdad7a9.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.data.carStatus === 3) ? _c('div', {
    staticClass: "reserved-icon-parent"
  }, [_c('img', {
    attrs: {
      "src": "//img.souche.com/20170309/png/e396723127b40cc9bc292ddf63d2e2fa.png"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "car-item-content"
  }, [_c('div', {
    staticClass: "car-name"
  }, [_vm._v(_vm._s(_vm.data.fullName))]), _vm._v(" "), _c('div', {
    staticClass: "car-main"
  }, [(_vm.isToolNewTangeche) ? [_c('span', {
    staticClass: "car-main-item"
  }, [_vm._v(_vm._s(_vm.data.price || '面议'))]), _vm._v(" "), (_vm.data.prepaidLeaseAmount) ? _c('span', {
    staticClass: "car-main-item"
  }, [_vm._v("首付" + _vm._s(_vm.data.prepaidLeaseAmount) + "万")]) : _vm._e()] : (_vm.hasTangeche) ? [_c('span', {
    staticClass: "car-main-item"
  }, [_c('span', [_vm._v("首付")]), _vm._v(" "), _c('span', {
    staticClass: "car-main-important"
  }, [_vm._v(_vm._s(_vm.data.prepaidLeaseAmount))]), _vm._v(" "), _c('span', [_vm._v("万")])]), _vm._v(" "), _c('span', {
    staticClass: "car-main-item"
  }, [_vm._v("月供" + _vm._s(_vm.data.installmentPayment) + "元")])] : (_vm.data.price) ? _c('span', [_vm._v(_vm._s(_vm.data.price))]) : _c('span', [_vm._v(_vm._s(_vm.data.price))]), _vm._v(" "), (_vm.supportloan) ? [_c('span', {
    staticClass: "gap"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("首付")]), _vm._v(" "), _c('span', {
    staticClass: "car-main-important-loan"
  }, [_vm._v(_vm._s(_vm.data.prepaidLeaseAmount))]), _c('span', [_vm._v("万")])] : _vm._e()], 2), _vm._v(" "), (_vm.hasTangeche && !_vm.isNew && _vm.data.price) ? _c('div', {
    staticClass: "car-ex"
  }, [_vm._v("\n            售价 " + _vm._s(_vm.data.price) + "元\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "car-secondary"
  }, [_c('span', {
    staticClass: "car-secondary-item"
  }, [_vm._v(_vm._s(_vm.data.cityName))]), _vm._v(" "), (!_vm.isNew) ? [_c('span', {
    staticClass: "car-secondary-item"
  }, [_vm._v(_vm._s(_vm.data.year))]), _vm._v(" "), _c('span', {
    staticClass: "car-secondary-item"
  }, [_vm._v(_vm._s(_vm.data.mileage) + "万公里")])] : (_vm.data.newPriceWanStr) ? _c('span', {
    staticClass: "car-secondary-item"
  }, [_vm._v("指导价 " + _vm._s(_vm.data.newPriceWanStr) + "万")]) : _vm._e()], 2), _vm._v(" "), (_vm.hasTangeche) ? _c('div', {
    staticClass: "tangeche-icon-parent"
  }, [_c('img', {
    attrs: {
      "src": "//img.souche.com/20170309/png/f0251232e5efd09e575f9bbd9811f6b6.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.supportloan) ? _c('div', {
    staticClass: "loan-icon-parent"
  }, [_c('img', {
    attrs: {
      "src": "//img.souche.com/f2e/47793ebdf74b352b51e6bc7f6e7d4159.png"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48f5a512!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@souche-f2e/wangzhan-dependencies-car-item/vue/Default.vue
// module id = 105
// module chunks = 2 3 4 5